import { api } from '@/api/appGatewayServerApi'

const ngWordsJsonUrl =
  process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
    ? 'https://reality-public.akamaized.net/moderation/ngwords.json'
    : 'https://storage.googleapis.com/vlive-lab-public-origin/moderation/ngwords.json'

interface NgWordsJson {
  ngWords: {
    level: number
    words: string[]
  }[]
}

let initialized = false
const ngWords: { [k: number]: string } = {
  1: '',
  2: '',
}

async function fetchNgWords() {
  try {
    if (initialized) return
    const json: NgWordsJson = await fetch(ngWordsJsonUrl).then((c) => c.json())
    setNgWords(json)
    initialized = true
  } catch {
    // do nothing
  }
}

export function setNgWords(json: NgWordsJson) {
  for (const wordlist of json.ngWords) {
    ngWords[wordlist.level] = wordlist.words.join('|')
  }
}

export async function comment(mediaId: number, message: string) {
  await fetchNgWords()
  await api().live.comment({
    mediaId,
    comment: moderateMessage(message),
  })
}

export function moderateMessage(message: string) {
  const pattern1 = `(?:^|[\\s ])(${ngWords[1]})(?=$|[\\s ])`
  message = moderate(message, pattern1)

  const pattern2 = `(${ngWords[2]})`
  message = moderate(message, pattern2)

  return message
}

function moderate(message: string, pattern: string) {
  const regexp = new RegExp(pattern, 'ig')
  const matches = message.match(regexp) || []

  for (const match of matches) {
    // スペースがついている場合はスペースを維持したまま置き換え対象を作成
    const replacer =
      match.trim().length === match.length
        ? '*'.repeat(match.length)
        : match[0] + '*'.repeat(match.length - 1)

    message = message.replace(new RegExp(match), replacer)
  }
  return message
}
